import api from "./axios";

// ── Firm-admin (read side) ────────────────────────────────────────────────
// Published release history + the current version.
export const getChangelog = () => api.get("/announcements/changelog");
// Published popup entries this admin hasn't dismissed yet.
export const getPopupAnnouncements = () => api.get("/announcements/popup");
// Acknowledge the whole pending popup backlog (one-time dismissal).
export const markAnnouncementsSeen = () => api.post("/announcements/seen");

// ── Super admin (authoring) ───────────────────────────────────────────────
export const listAnnouncements = (params = {}) => api.get("/super/announcements", { params });
export const createAnnouncement = (payload) => api.post("/super/announcements", payload);
export const updateAnnouncement = (id, payload) => api.put(`/super/announcements/${id}`, payload);
export const deleteAnnouncement = (id) => api.delete(`/super/announcements/${id}`);
